// find
export const FIND_REPRINT_REQUEST = "FIND_REPRINT_REQUEST";
export const FIND_REPRINT_SUCCESS = "FIND_REPRINT_SUCCESS";
export const FIND_REPRINT_FAIL = "FIND_REPRINT_FAIL";

export const REPRINT_CLEAR_ERROR = "REPRINT_CLEAR_ERROR";